export const API_CONSTANTS = {
  BASE_URL: "https://8m7y91ke3m.execute-api.ap-southeast-1.amazonaws.com/prod/",
  UPLOAD_BASE_URL:
    "https://3oapezb69j.execute-api.ap-southeast-1.amazonaws.com/prod/",
  CLIENT_PROGRESS_Dev_BASE_URL:
    "https://lexhue53xg.execute-api.ap-southeast-1.amazonaws.com/prod/",
  USER_CREATE: "User-create",
  USER_LIST: "user_list",
  DELETE_USER: "delete_user",
  UPDATE_USER: "update-user",
  PROJECT: "project",
  INFRA: "infra",
  CLIENT: "client",
  INFRA_LIST: "infra_list",
  CLIENT_ASSIGN: "client_assign",
  MODEL: "model",
  DATA_QC_STATUS: "data_qc_status",
  JENKINS: "jenkins",
  LOG: "log",
  EDA_IMAGE: "eda-image",
  MODEL_TRAIN: "model-train",
  CLIENT_PROGRESS: "client-progress",
  PRE_SIGNED_URL:
    "https://3oapezb69j.execute-api.ap-southeast-1.amazonaws.com/prod/pre-signed-url",
};
